import { ASSISTANT } from "V2.0/HomePages/Assistants/Assistant";

export const CONVERSATION_SOURCE = {
  WHATSAPP: {
    id: "WHATSAPP",
    label: "Whatsapp",
  },
  SMS: { id: "SMS", label: "Sms" },
  EMBEDDEDCHAT: { id: "EMBEDDEDCHAT", label: "Embdedded Chat" },
  MESSENGER: { id: "MESSENGER", label: "Messenger" },
  INBOUNDVOICE: { id: "INBOUNDVOICE", label: "Inbound voice" },
  OUTBOUNDVOICE: { id: "OUTBOUNDVOICE", label: "Outbound voice" },
  WEBCALL: { id: "WEBCALL", label: "Web call" },
};

export function getConversationSourcesForAssistantType(assistantType) {
  switch (assistantType) {
    case ASSISTANT.VOICE:
      return [
        CONVERSATION_SOURCE.INBOUNDVOICE,
        CONVERSATION_SOURCE.OUTBOUNDVOICE,
      ];
    case ASSISTANT.CHAT:
      return [CONVERSATION_SOURCE.EMBEDDEDCHAT];
    case ASSISTANT.INSTAGRAM:
      return [CONVERSATION_SOURCE.INSTAGRAM];
    case ASSISTANT.MESSENGER:
      return [CONVERSATION_SOURCE.MESSENGER];
    case ASSISTANT.SMS:
      return [CONVERSATION_SOURCE.SMS];
    case ASSISTANT.WHATSAPP:
      return [CONVERSATION_SOURCE.WHATSAPP];
    default:
      return Object.values(CONVERSATION_SOURCE);
  }
}
